import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ChevronUp } from '@outdoor-voices/ui';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import addClass from '../../utils/dom/addClass';
import FAQList from '../FAQList';
import scrollToHash from '../../utils/dom/scrollToHash';
import scrollTop from '../../utils/dom/scrollTop';
import Spinner from '../icons/Spinner';
import css from './FAQs.module.scss';
import getFAQs from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var groupId = function groupId(group) {
  return group.slug ? group.slug : "group-".concat(group.id);
};

var scroll = function scroll(event) {
  var nav = document.querySelector('.ov-nav-wrap');
  var hash = event.currentTarget.hash;
  var target = document.querySelector(hash);
  event.preventDefault();
  addClass(target, 'on');
  window.history.replaceState({}, '', window.location.pathname + hash);
  var scrollTo = target.getBoundingClientRect().top + (scrollTop() - nav.offsetHeight - 10);
  window.scrollTo({
    top: scrollTo,
    behavior: 'smooth'
  });
};

var FAQs = function FAQs(_ref) {
  var groups = _ref.groups;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      topVisible = _useState2[0],
      setTopVisible = _useState2[1];

  useEffect(function () {
    var onScroll = function onScroll() {
      var shouldShow = scrollTop() > 100;

      if (shouldShow && !topVisible) {
        setTopVisible(true);
      }

      if (!shouldShow && topVisible) {
        setTopVisible(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [topVisible]);
  useEffect(function () {
    var hash = window.location.hash;
    var target = hash ? document.querySelector(hash) : false;

    if (target) {
      addClass(target, 'on');
      setTimeout(scrollToHash, 250);
    }
  }, []);

  var goToTop = function goToTop() {
    window.history.replaceState({}, '', window.location.pathname);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.root,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.toc,
        children: groups.map(function (group) {
          var id = group.slug ? group.slug : "group-".concat(group.id);
          return /*#__PURE__*/_jsxs("nav", {
            "aria-label": "Navigation For Each Question Topic",
            className: css.nav,
            role: "navigation",
            children: [/*#__PURE__*/_jsx("h2", {
              children: /*#__PURE__*/_jsx("a", {
                "aria-label": "Read All Frequently Asked Questions About ".concat(group.title),
                href: "#".concat(groupId(group)),
                dangerouslySetInnerHTML: {
                  __html: group.title
                },
                onClick: scroll
              })
            }, id), /*#__PURE__*/_jsx("ul", {
              className: css.list,
              children: group.faqs.edges.map(function (_ref2) {
                var faq = _ref2.node;
                var faqId = faq.slug ? faq.slug : "toc-faq-".concat(faq.id);
                return /*#__PURE__*/_jsx("li", {
                  className: css.item,
                  children: /*#__PURE__*/_jsx("a", {
                    href: "#".concat(faqId),
                    dangerouslySetInnerHTML: {
                      __html: faq.title
                    },
                    onClick: scroll,
                    "aria-label": "Scroll To ".concat(faq.title, " Topic")
                  })
                }, faqId);
              })
            })]
          }, "toc-".concat(id));
        })
      }), groups.map(function (group) {
        var id = groupId(group);
        return /*#__PURE__*/_jsxs("div", {
          id: id,
          children: [/*#__PURE__*/_jsx("h2", {
            className: css.title,
            children: group.title
          }), /*#__PURE__*/_jsx(FAQList, {
            faqs: group.faqs
          })]
        }, id);
      })]
    }), /*#__PURE__*/_jsxs("button", {
      "aria-label": "Scroll Back To The Top Of All Questions",
      className: cc([css.scrollTopButton, _defineProperty({}, css.visible, topVisible)]),
      onClick: goToTop,
      type: "button",
      children: [/*#__PURE__*/_jsx(ChevronUp, {}), "Top"]
    })]
  });
};

FAQs.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

var FAQSLoader = function FAQSLoader() {
  var _useQuery = useQuery({
    query: getFAQs,
    variables: {
      displayOnFaqLanding: false
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      className: css.loading,
      "aria-busy": "true",
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  var groups = data.faqs.edges.map(function (_ref4) {
    var node = _ref4.node;
    return node;
  });
  return /*#__PURE__*/_jsx(FAQs, {
    groups: groups
  });
};

export default FAQSLoader;